module.exports = __webpack_public_path__ + "static/img/about.4af88ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/travel/about.png
// module id = sMnw
// module chunks = 1